import AbstractRepository from "@/repositories/AbstractRepository";

export default class OwnerRepository extends AbstractRepository {
    protected static resource: string = "owner";

    protected static defaultFields: string[] = [
        "uuid",
        "canonicalName",
        "fullName",
        "parent.uuid",
        "ptfFeatures.uuid",
        "ptfFeatures.code",
    ];
}
